import WebApiService from "@/services/webapi.service.js";

const state = {
    cataloghi: null
}

const getters = {
    getCataloghi: (state) =>{
        return state.cataloghi ?? JSON.parse(sessionStorage.getItem("agentiCataloghi"));
    }
}

const mutations = {
    setCataloghi: (state, catList) =>{
        state.cataloghi = catList;
        sessionStorage.setItem('agentiCataloghi',JSON.stringify(state.cataloghi));
    }
}
const actions = {
    getCataloghiApi: ({commit},data) =>{
        return WebApiService.get("Cataloghi", data.Token, null, null).then(
            (data) =>{
                if(data != null && data.status == 200){
                    commit("setCataloghi",data.data);
                }
            }
        );
    }
}

export default {
    namespeced: true,
    state,
    getters,
    mutations,
    actions
}